import amplitude from 'amplitude-js';
import { DateTime, Settings } from 'luxon';

export const initAmplitude = (): void => {
  amplitude.getInstance().init(window.el8Globals.AMPLITUDE_API_KEY, null, { disableCookies: true });
};

export const logEvent = (eventType: string, eventData = {}): void => {
  amplitude.getInstance().logEvent(eventType, eventData);
};
export const handleAmplitudeError = (eventName: string, err: Error): void => {
  // eslint-disable-next-line no-console
  console.warn(`Failed to log event "${eventName}":`, err);
};

/**
 * Helper functions for analytics
 */

let startTime: DateTime;

export const setStartTime = (): void => {
  startTime = DateTime.fromObject({ zone: Settings.defaultZone });
};

export const getStartTime = (): DateTime => startTime;
